import { render } from "./PepStep.vue?vue&type=template&id=524db696"
import script from "./PepStep.vue?vue&type=script&lang=js"
export * from "./PepStep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__